export const FONT_WEIGHT = [
  { name: 'Remain unchanged', value: null },
  { name: 'Thin 100', value: 100 },
  { name: 'Semi Thin 200', value: 200 },
  { name: 'Light 300', value: 300 },
  { name: 'Regular 400', value: 400 },
  { name: 'Medium 500', value: 500 },
  { name: 'Semi Bold 600', value: 600 },
  { name: 'Bold 700', value: 700 },
  { name: 'Super Bold 800', value: 800 },
  { name: 'Boldest', value: 900 },
];

export const GEM_METER_TRIGGER_EVENT = {
  PUBLISH_PAGE: 'PUBLISH_PAGE',
  SAVE_PAGE: 'SAVE_PAGE',
  PAGE_SETTING_LAZY_LOAD: 'PAGE_SETTING_LAZY_LOAD',
  PAGE_SETTING_SEO: 'PAGE_SETTING_SEO',
};
